<template>
    <div class="expert-work-session">
        <aside class="card">
            <div class="label">ID сессии</div>

            <div class="value">{{ session.id }}</div>

            <template v-if="user">
                <div class="label">Пользователь</div>

                <div class="value">{{ userName }}</div>
                <div class="value">{{ user.tel | phone }}</div>

                <a
                    class="link"
                    :href="userLink"
                    target="_blank"
                >Перейти в профиль</a>
            </template>

            <div class="label">Действия</div>

            <div
                class="link"
                @click="cancel"
            >Отказаться от проверки</div>
        </aside>

        <main class="card">
            <!--suppress HtmlUnknownTarget -->
            <iframe :src="session['sessionUrl']"/>
        </main>
    </div>
</template>

<script>
import { makeURL, post } from '@/tools/http';

export default {
    name: 'ExpertWorkSession',
    props: {
        type: String,
        eid: Number,
        eventPath: String,
        session: Object,
        user: Object,
    },
    computed: {
        userName() {
            if (!this.user) return '';

            return [
                this.user.surname,
                this.user.name,
            ].filter(a => a).join(' ');
        },
        userLink() {
            if (!this.user) return '/';

            return makeURL('admin', `platform/users/${this.session.userId}`);
        },
    },
    methods: {
        async cancel() {
            await post('examination', this.session['cancelUrl'].slice(1));

            // noinspection ES6MissingAwait
            this.$router.push(this.eventPath);
        },
        message({ data }) {
            if (data['event_type'] == 'session_complete') {
                // noinspection ES6MissingAwait
                this.$router.push(this.eventPath);
            }
        },
    },
    created() {
        window.addEventListener('message', this.message);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.message);
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/rem';

    .expert-work-session {
        display: flex;
        align-items: flex-start;
        margin-bottom: rem(32);
    }

    .card {
        background: #fff;
        box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);
        border-radius: rem(4);
    }

    .label {
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(24);
        margin-top: rem(24);
        margin-bottom: rem(8);
        color: #98A0A9;

        &:first-of-type {
            margin-top: 0;
        }
    }

    .value {
        font-size: rem(18);
        line-height: rem(26);
        margin-bottom: rem(8);
    }

    .link {
        display: block;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #4663AB;
        cursor: pointer;
        margin-top: rem(10);
    }

    aside {
        width: rem(354);
        margin-right: rem(32);
        padding: rem(24);
    }

    main {
        width: rem(770);
        height: rem(851);
        padding: rem(8);

        iframe {
            border: none;
            width: 100%;
            height: 100%;
        }
    }
</style>
